import classNames from 'classnames';
import React, { FC, MouseEventHandler, PropsWithChildren, HTMLAttributeAnchorTarget } from 'react';

import styles from './Link.styles.m.css';

type TILinkColor = 'base' | 'primary' | 'secondary' | 'title-link-2';

interface ILinkProps {
  className?: string;
  isDisabled?: boolean;
  color?: TILinkColor;
  underline?: boolean;
  onClick?: MouseEventHandler;
  href?: string;
  target?: HTMLAttributeAnchorTarget;
}

export const Link: FC<PropsWithChildren<ILinkProps>> = ({
  className,
  children,
  isDisabled = false,
  color = 'secondary',
  underline = true,
  onClick,
  href,
  target,
}) => {
  const classes = classNames(styles.container, className, styles[`${color}-color`], {
    [styles.underline]: underline,
  });

  const handleMouseDown: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement> = (e) => {
    e.preventDefault();
  };

  if (href) {
    return (
      <a
        className={classes}
        href={href}
        target={target}
        onMouseDown={handleMouseDown}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={classes}
      disabled={isDisabled}
      onClick={onClick}
      onMouseDown={handleMouseDown}
    >
      {children}
    </button>
  );
};
